import type React from 'react';
import { useDictionary } from './use-dictionary';

/**
 * Starts the word list downloading for a game route, so it is there by the time a guess is made. A stand-in
 * until the game screens (WH-189) call `useDictionary` themselves.
 */
export const DictionaryPreload: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useDictionary();
  return children;
};
